var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Directional chevron")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.62 4.048 5.053 4.863A4.27 4.27 0 0 1 16 12a4.27 4.27 0 0 1-1.328 3.089L9.62 19.952a.175.175 0 0 1-.24 0l-1.611-1.55a.14.14 0 0 1 0-.203l5.308-5.109.06-.066c.294-.283.442-.653.443-1.024a1.42 1.42 0 0 0-.443-1.024l-.04-.046L7.769 5.8a.14.14 0 0 1 0-.203l1.61-1.55a.175.175 0 0 1 .241 0"
  })));
};
export default SvgChevron;